import { Injectable } from '@angular/core';
import { ITraveller, IXId } from 'libraries/service/resources/booking/interfaces/IGetBookings';
import { ITravellerColumn, PriceColumnType } from '../ITablePrice';

@Injectable()
export class TravellersMapperService {
    public getTravellerColumns(travellers?: ITraveller[]): ITravellerColumn[] {
        return (travellers || [])
            .map((traveller: ITraveller): ITravellerColumn => ({
                key: this.getTravellerKey(traveller),
                traveller,
                type: PriceColumnType.traveller
            }));
    }

    public getTravellerKey(traveller: ITraveller): string {
        return traveller.xId;
    }
}